<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    
    import { delay } from '@dotdash/proxima-shared/utils';
    import { rmniStore } from 'store/index.js';
    import {
        sendImpressionTelemetry,
        sendProductViewedTelemetry,
        sendViewedTelemetry,
        sendErrorTelemetry,
    } from 'tracking/index.js';
    import DisplayAd from './components/DisplayAd.svelte';
    import { isJsonString } from 'utils/config.js';
    
    
    export let isBiu: boolean = false;
    export let isMws: boolean = false;
    let config;
    let viewed;
    let site;
    let theme;
    $: config;
    $: site = `site-${$rmniStore.rmniData.siteInfo.site}`;
    $: theme = `theme-${$rmniStore.rmniData.retailer}`;

    async function postMessageHandler(event: MessageEvent) {
        //if (event.origin !== window.location.origin) return;
        // LRS sends message to RMNI container iframe
        // when retailer RMNI container is in view
        // Send message when --show SCSS modifier
        // is placed on container

        const data = isJsonString(event.data) ? JSON.parse(event.data) : event.data;
        if (data.type === 'rmniData') {
            console.log('RMNI postMessage data received: ', data);
            await rmniStore.initialize(data);
            config = $rmniStore.config;
            await delay(100); // wait for rmni data to be set before accessing
            if (!$rmniStore.impressionSent) {
                console.log('RMNI config', config);
                await sendImpressionTelemetry();
            }
            console.log('RMNI state', $rmniStore);
        }

        if (data.type === 'rmniViewed') {
            viewed = setInterval(() => {
                if ($rmniStore.impressionSent) {
                    sendViewedTelemetry();
                    sendProductViewedTelemetry();
                    clearInterval(viewed);
                }
            }, 100);
        }
    }

    // allow RMNI adTag preview outside DDM
    async function allowExternalPreview() {
        // This will initialize RMNI (no data for telemetry)
        config = await rmniStore.initialize();
        await sendImpressionTelemetry();
        await delay(100);
        sendViewedTelemetry();
        sendProductViewedTelemetry();
    }

    onMount(() => {
        try {
            if (window.top && Object.hasOwnProperty.call(window.top, 'Mntl')) {
                window.addEventListener('message', postMessageHandler);
                window.top.postMessage({type: 'rmniReady'}, '*');
            } else {
                allowExternalPreview();
            }
        } catch (err: any) {
            allowExternalPreview();
            sendErrorTelemetry('External Site: ' + err.message);
        }
    })

    onDestroy(() => {
        window.removeEventListener('message', postMessageHandler);
    })
</script>

<div id="rmni" class={`${site} ${theme}`}>
    {#if config}
    <DisplayAd
        config={config}
        isBiu={isBiu}
        isMws={isMws}
        polParams={$rmniStore.polParams}
    />
    {/if}
</div>

<style lang="scss">
    @use '@dotdash/proxima-shared/dist/styles/retailer-themes.scss' as *;
    @use '@dotdash/proxima-shared/dist/styles/site-themes.scss' as *;
    
    :global(html) {
        overflow: hidden;
    }
    :global(body) {
        padding: 0;
        margin: 0;
        border: 0;
        overflow: hidden;
    }
</style>